export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Sobre */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#fbbf24]">Sobre Nós</h3>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Especialistas em sublimação e personalização de produtos. Transformamos suas ideias em realidade com qualidade e criatividade.
            </p>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#fbbf24]">Contato</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#fbbf24] mt-1"></i>
                <p className="text-gray-300">
                  Rua das Safiras, 32, Loja B<br />
                  Rocha Miranda, Rio de Janeiro - RJ<br />
                  CEP 21511-380
                </p>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-[#fbbf24]"></i>
                <p className="text-gray-300">
                  Seg a Sex: 9h às 18h<br />
                  Sáb: 9h às 13h
                </p>
              </div>
              <a
                href="https://wa.me/5521992215234"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-gray-300 hover:text-[#fbbf24] transition-colors"
              >
                <i className="ri-whatsapp-line"></i>
                <span>(21) 99221-5234</span>
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#fbbf24]">Links Rápidos</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/" className="text-gray-300 hover:text-[#fbbf24] transition-colors">
                  Início
                </a>
              </li>
              <li>
                <a href="/servicos" className="text-gray-300 hover:text-[#fbbf24] transition-colors">
                  Serviços
                </a>
              </li>
              <li>
                <a href="/portfolio" className="text-gray-300 hover:text-[#fbbf24] transition-colors">
                  Portfólio
                </a>
              </li>
              <li>
                <a href="/como-funciona" className="text-gray-300 hover:text-[#fbbf24] transition-colors">
                  Como Funciona
                </a>
              </li>
              <li>
                <a href="/contato" className="text-gray-300 hover:text-[#fbbf24] transition-colors">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Redes Sociais */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#fbbf24]">Redes Sociais</h3>
            <div className="flex gap-3 mb-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-700 hover:bg-[#1e3a8a] rounded-full flex items-center justify-center transition-colors"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-700 hover:bg-[#dc2626] rounded-full flex items-center justify-center transition-colors"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://wa.me/5521992215234"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-700 hover:bg-green-600 rounded-full flex items-center justify-center transition-colors"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
            <a
              href="/admin/login"
              className="inline-flex items-center gap-2 text-xs text-gray-500 hover:text-gray-300 transition-colors"
            >
              <i className="ri-lock-line"></i>
              <span>Área Administrativa</span>
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} JR Gráfica e Sublimação. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
